var $ = jQuery;
$(function() {
    var $menu_toggle = $('.menu-toggle');
    var $close_menu = $('.close-nav');

    $close_menu.click(function() {
        $('body').removeClass('menu-open');
        $('#page').removeClass('menu-open');
        $('.main-navigation-outer').removeClass('menu-open');
        $($(this)).parent().removeClass('menu-open');
    });

    $menu_toggle.click(function() {
        $('body').addClass('menu-open');
        $('#page').addClass('menu-open');
        $('.main-navigation-outer').addClass('menu-open');
        $($(this)).parent().addClass('menu-open');
    });
});